import { Title, useGetList, useStore } from "react-admin";
import { Box, Typography, Paper, useMediaQuery } from "@mui/material";
import { useState } from "react";
import CustomFilter from "features/CustomFilter";
import { ALL_OPTIONS } from "features/filters/constants";
import { administrationRequests } from "api/administrationApi";
import { CourseChoices } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";
import UnallocatedStudentsTable from "./components/UnallocatedStudentsTable";

const STORE_KEY = "unallocatedStudents.filters";

const ListUnallocated = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const [studentFilters, setStudentFilters] = useStore(STORE_KEY, null);

  // Pre-filter draft, committed to `studentFilters` on "Покажи".
  const [specialityId, setSpecialityId] = useState(studentFilters?.specialityId ?? null);
  const [instructionLanguageId, setInstructionLanguageId] = useState(studentFilters?.instructionLanguageId ?? null);
  const [course, setCourse] = useState(studentFilters?.course ?? null);

  const { data: specialities } = useGetList(administrationRequests.getSpecialitiesSelect(), ALL_OPTIONS);
  const { data: languages } = useGetList(
    administrationRequests.getInstructionLanguagesSelect(),
    { ...ALL_OPTIONS, filter: { specialityId } },
    { enabled: Boolean(specialityId) },
  );

  const changeSpeciality = value => {
    setSpecialityId(value);
    setInstructionLanguageId(null);
    setCourse(null);
  };
  const changeLanguage = value => {
    setInstructionLanguageId(value);
    setCourse(null);
  };
  return (
    <>
      {!studentFilters && <Title title="Неразпределени студенти" />}
      <CustomFilter
        title="Филтри за студенти"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={[
          {
            label: "Специалност",
            type: "autocomplete",
            value: specialityId,
            setValue: changeSpeciality,
            choices: specialities ?? [],
          },
          ...(specialityId
            ? [
                {
                  label: "Език на обучение",
                  type: "select",
                  value: instructionLanguageId ?? "",
                  setValue: changeLanguage,
                  choices: languages ?? [],
                },
              ]
            : []),
          ...(instructionLanguageId
            ? [{ label: "Курс", type: "select", value: course ?? "", setValue: setCourse, choices: CourseChoices }]
            : []),
        ]}
        buttonLabel="Покажи"
        buttonDisabled={!specialityId || !instructionLanguageId || !course}
        buttonOnClick={() => setStudentFilters({ specialityId, instructionLanguageId, course })}
      />
      {!studentFilters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{ display: "flex", justifyContent: "center", gap: 3 }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за студенти.
            </Typography>
          </Box>
        </Paper>
      ) : (
        <UnallocatedStudentsTable studentFilters={studentFilters} />
      )}
    </>
  );
};

export default ListUnallocated;
